import { resetWhenRouterChange } from '@ui/utils/zustandMiddleware';
import { create } from 'zustand';

import usePersistentContext from './usePersistentContext';

export type StrategySettingsStore = {
  slippage: number | null;
  setSlippage: (slippage: number) => void;
};

export const useStrategySettingsStore = create<StrategySettingsStore>(
  resetWhenRouterChange((set) => ({
    slippage: null,
    setSlippage: (slippage: number) => set({ slippage }),
  })),
);

export const useStrategySlippage = () => {
  const { slippage: appliedSlippage, setSlippage: setAppliedSlippage } =
    useStrategySettingsStore();
  const [persistedSlippage, setPersistedSlippage] =
    usePersistentContext('strategy-slippage');
  const slippage = appliedSlippage ?? parseInt(persistedSlippage ?? '100');

  const setSlippage = (slippage: number) => {
    setPersistedSlippage(`${slippage}`);
    setAppliedSlippage(slippage);
  };

  return { slippage, setSlippage };
};
